import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useKeybind } from '../../hooks';
import { useModalRegistry } from '../../contexts/modal-registry';
import { ModalContextProvider } from './context';
export function ModalRoot({ children, content, onClose }) {
    const { openModal, closeModal } = useModalRegistry();
    useEffect(() => {
        openModal();
        return () => closeModal();
    }, [openModal, closeModal]);
    useKeybind({ key: 'Escape', onKeyPress: onClose });
    return (_jsx(ModalContextProvider, { initialView: { id: 'root', component: content }, onClose: onClose, children: children }));
}
